import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { Component, ViewEncapsulation } from '@angular/core';

import {
  SgAsyncGuiRef,
  SgAsyncGuiPhase,
  SgAsyncGuiEvent,
  isAsyncGuiEvent,
  isAsyncGuiPhase,
} from '@sg/ui-kit/async-gui';

export interface SgAsyncGuiDialogBoxContext {
  errorMessage?: string;
  successMessage?: string;
}

const DEFAULT_CONTEXT = {
  errorMessage: 'An Error has occured.',
  successMessage: 'Success.',
};

@Component({
  selector: 'sg-async-gui-dialog-box',
  templateUrl: './async-gui-dialog-box.component.html',
  styleUrls: ['./async-gui-dialog-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SgAsyncGuiDialogBoxComponent {
  data: SgAsyncGuiDialogBoxContext;
  readonly phase$: Observable<SgAsyncGuiPhase>;

  constructor(public asyncGuiRef: SgAsyncGuiRef<boolean, SgAsyncGuiDialogBoxContext>) {
    this.data = Object.assign({}, DEFAULT_CONTEXT, asyncGuiRef.data || {});

    this.phase$ = <any>asyncGuiRef.events.pipe(
      tap((e) => isAsyncGuiEvent(e) && this.handleEvent(e)),
      filter((e) => isAsyncGuiPhase(e)),
      tap((phase) => this.handlePhase(phase as any))
    );
  }

  private handlePhase(phase: SgAsyncGuiPhase): void {
    switch (phase.type) {
      case 'resolve':
      case 'reject':
        // this event tells us that the async operation has finished.
        // we now need to initiate a close process, or if it's an error we might want to wait for a user click...
        setTimeout(() => this.asyncGuiRef.close(), 2000);
        break;
    }
  }

  private handleEvent(event: SgAsyncGuiEvent): void {
    switch (event.type) {
      case 'userCloseRequested':
        // User requested to close the dialog, this can be either through a backdrop click or a keyboard esc click.
        // the managing service will not take action, if we want to close we can but we can also ignore.
        break;
      case 'forceClosing':
        // do stuff (sync) before the managing service will close this component (no control over it)
        break;
    }
  }
}
